import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import SET_USER from './types';
import { fetchUser } from '~/services/user';
export default {
  fetchUser(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;

      try {
        var user = yield fetchUser(_this);
        commit(SET_USER, user);
      } catch (err) {
        _this.$logger.error(err);
      }
    })();
  }

};